import { Component, OnInit, ViewChild, Inject, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { MatSort, MatPaginator, MatTableDataSource, MatDialog, MatSnackBar, MatDialogRef, MAT_DIALOG_DATA, MatSidenav } from '@angular/material';
import { Observable } from 'rxjs';
import { PortfolioService } from 'src/app/services/portfolio/portfolio.service';
import { FilterService } from 'src/app/services/filter.service';
import { AddEvidenceModalComponent } from './add-evidence-modal/add-evidence-modal.component';
import { Router, ActivatedRoute } from '@angular/router';
import { LearnerService } from 'src/app/services/learner.service';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component'
import * as _ from 'lodash';
import { saveAs } from "file-saver";
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AssetService } from 'src/app/services/asset.service';
import { UtilityService } from 'src/app/services/utility.service'

@Component({
  selector: 'app-evidences',
  templateUrl: './evidences.component.html',
  styleUrls: ['./evidences.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ]),
  ],
})
export class EvidencesComponent implements OnInit {

  sort: MatSort;
  paginator: MatPaginator;
  displayedColumns: string[] = ['reference', 'title', 'actions'];
  dataSource: MatTableDataSource<any>;
  allEvidenceses: any[];
  learnerId: any;
  afterFilter: any;
  filterActive: boolean;
  loading: boolean;
  currentLearner
  currentJob
  isSpinner: boolean
  isSpinnerIndex
  noDataMsg = {
    title: "No Evidences!",
    data: "No evidence added yet!"
  }
  jobId: any
  @Input('selectedJob') selectedJob
  @Input('job') job
  @Input('selecetdLearner') selecetdLearner
  @Output() getFileDetails: EventEmitter<any> = new EventEmitter<any>();
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();
  @ViewChild('sidenav', { static: false }) public mydsidenav: MatSidenav;
  previousIndex: any;
  noFiles = {
    title: "No Files!",
    data: "There is no files added in this evidence!"
  }
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _portfolioService: PortfolioService,
    public _filter: FilterService,
    public activatedRoute: ActivatedRoute,
    public _router: Router,
    public _learnerService: LearnerService,
    public _assetService: AssetService,
    public _utilityServices: UtilityService
    // public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA)
  ) {
    this.dataSource = new MatTableDataSource(this.allEvidenceses);
  }


  ngOnInit() {
    this.loading = true
    this._assetService.closeDisplayFile(true)
    this.activatedRoute.params.subscribe(param => {
      console.log('params', param);
      this.learnerId = param.id
    })
    this.activatedRoute.queryParams.subscribe(param => {
      console.log("query params in evidence", param);
      if (param && param.job) {

        this.jobId = param.job
      }
      if (param && param.jobId) {
        this.jobId = param.jobId
      }
      this.getEvidenceList()

    })
  }



  ngOnChanges(changes: SimpleChanges): void {


    this.activatedRoute.params.subscribe(param => {
      console.log('params', param);
      this.learnerId = param.id
    })

    this.activatedRoute.queryParams.subscribe(param => {
      console.log("query params in evidence", param);
      if (param && param.job) {

        this.jobId = param.job
      }
      if (param && param.jobId) {
        this.jobId = param.jobId
      }
      this.getEvidenceList()

    })

    if (changes.selecetdLearner && changes.selecetdLearner.currentValue) {
      this.currentLearner = changes.selecetdLearner.currentValue
      console.log("Hello Selected Learner ::", this.currentLearner)
      // this.getEvidenceList()
    }

    if (changes.job && changes.job.currentValue) {
      this.currentJob = changes.job.currentValue[0]
      console.log("what is the main changes to be update", this.currentJob);

    }


  }
  addEvidenceModal() {
    let data = {
      learnerId: this.learnerId,
      jobId: this.jobId
    }

    this._utilityServices.commonDialogBoxOpen(AddEvidenceModalComponent, data).afterClosed()
      .subscribe(res => {
        console.log('In evidence', res)
        if (!res) return
        else {
          this.allEvidenceses.push(res.data)
          for (let i = 0; i < this.allEvidenceses.length; i++) this.allEvidenceses[i]['index'] = i
          this.updateData(this.allEvidenceses)
        }
      })
  }

  viewQuiz(evi, index) {
    console.log("evi=========================", evi, index)
    if (evi.quizId) {
      this._router.navigate(['/appear-quiz'], { queryParams: { quizId: evi.quizId, learnerId: evi.learnerId, jobId: this.jobId } })
    } else {
      let data = {
        learnerId: this.learnerId,
        isEdit: true,
        evi: evi,
        jobId: this.jobId
      }
      this._utilityServices.commonDialogBoxOpen(AddEvidenceModalComponent, data)
        .afterClosed().subscribe(res => {
          console.log('In evidence', res)
          if (!res) return
          if (res.action == 'edit') {
            let index = _.findIndex(this.allEvidenceses, function (o) { return o._id == res.data[0]._id })
            if (index > -1) {
              this.allEvidenceses[index] = res.data[0]
              console.log("HELLO HERE IS THE REPONSE >>", this.allEvidenceses)
              for (let i = 0; i < this.allEvidenceses.length; i++) this.allEvidenceses[i]['index'] = i
              this.updateData(this.allEvidenceses)
            }
          }
          else if (res.action == 'delete') {
            let index = _.findIndex(this.allEvidenceses, function (o) { return o._id == res.data._id })
            if (index > -1) {
              this.allEvidenceses.splice(index, 1)
              for (let i = 0; i < this.allEvidenceses.length; i++) this.allEvidenceses[i]['index'] = i
              this.updateData(this.allEvidenceses)
            }
          }
        })
    }
  }

  applyFilter(searchText) {
    this.afterFilter = null
    this.filterActive = true;
    if (searchText === '') {
      this.updateData(this.allEvidenceses);
      this.filterActive = false;
    }
    let filteredEvidence = this._filter.filter1(searchText, this.allEvidenceses, ['title', 'evidenceNo']);
    this.updateData(filteredEvidence);
    if (filteredEvidence.length <= 0) {
      this.afterFilter = {
        title: "No Evidences!",
        data: "No evidence with matched search text found!"
      }
    }
  }

  // UTILITY

  updateData(data) {
    console.log("UPDATING DATA = ", data)
    console.log("Emitting event getLearnersFromComponent with learners = ", data);
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property);
      switch (property) {
        case 'instructor.name': return item.instructor.name;
        case 'client.name': return item.client.name;
        case 'location.title': return item.location.title;
        case 'course.title':
          if (item.course)
            return item.course.title;
        default: return item[property];
      }
    };
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    // this.loading = false;

  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


  // API CALLS

  getEvidenceList() {
    this._learnerService.getEvidenceByLearner(this.learnerId, this.jobId).subscribe(res => {
      console.log("RES of evidence in evidence tab", res);
      this.allEvidenceses = res
      this.loading = false
      this.updateData(this.allEvidenceses)
    })
  }


  allEvidenceDownload(isSingleEvidence, _id?, index?) {
    console.log("allEvidenceDownload", isSingleEvidence, _id, index, this.allEvidenceses);

    if (!isSingleEvidence) {
      this.loading = true
    }
    let data = {
      learnerId: this.learnerId,
      jobId: this.jobId,
      isSingleEvi: isSingleEvidence,
      eviId: _id
    }
    let tempIndex = this.allEvidenceses.findIndex((x) => x._id == _id)
    console.log("what is the temp index", tempIndex, index);
    this._utilityServices.openSnackBar("Download will begin automatically", "Ok")
    this.isSpinner = true
    this.isSpinnerIndex = index
    this._learnerService.allEvidenceDownload(data).subscribe((res) => {
      console.log("HELLO HERE IS RESPONSE:::", res.dat)
      let byteArray = new Uint8Array(res.data.data);
      console.log("======byteArray =======", byteArray)
      let blob = new Blob([byteArray], { type: 'application/pdf' });
      console.log("blobblobblobblobblob", blob)
      let title = 'evidence-' + this.currentLearner.name.split(' ').join('') + '' + this.currentJob.title.split(' ').join('_') + '.pdf'
      saveAs(blob, title);
      this.isSpinner = false
      this.loading = false
    }, (error) => {
      this.isSpinner = false
      this.loading = false
      console.log("reponse failed download ilp form", error);
    })
  }

  deleteEvi(eviId, evi) {
    if (evi.quizId) {
      // return true
    } else {
      //  return false

      this._utilityServices.commonDialogBoxOpen(DeleteConfirmModalComponent, 'Evidence').afterClosed()
        .subscribe(confirm => {
          if (confirm == '') return
          else if (confirm == 'yes') {
            console.log('DELETE')
            this.loading = true;
            this._learnerService.deleteEvidence(eviId, this.learnerId, this.jobId).subscribe(evidence => {
              this._utilityServices.openSnackBar("Evidence Delete successfully!", "Ok")
              // this.openSnackBar("Evidence Delete successfully!", "Ok");
              console.log("EVIDENCE RESPONSE", evidence)
              this.loading = false;
              let index = _.findIndex(this.allEvidenceses, function (o) { return o._id == eviId })
              if (index > -1) {
                this.allEvidenceses.splice(index, 1)
                this.updateData(this.allEvidenceses)
              }
            }, err => {
              this.loading = false;
              console.log("some error ocure Delete Evidence:", err)
            });
          }
        })
    }
  }


  disabled(evi) {
    if (evi.quizId) {
      return true
    } else {
      return false
    }
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }

  // fileDetails(event) {
  //   console.log("event ====", event);
  //   this.previousIndex = event.index
  //   // this.openFilesSideNav.emit({ event })
  //   this._learnerService.displayFile(event)
  //   // this.openDialog(FileDetailsComponent, event.file).subscribe(file=>{
  //   //   console.log("Test")
  //   // })

  // }

  fileDetails(event) {
    console.log("hey this event emit call ")
    console.log("event ====", event.file);
    this.previousIndex = event.index
    this.openFilesSideNav.emit({ event })
    this._assetService.displayFile(event)
  }

}
